export const normalizeImageUrl = (url: string): string => {
    if (!url) return url;

    const s3Pattern = 'tbrc-pb.s3.ap-south-1.amazonaws.com';
    const cloudFrontHost = 'd1lt5802h39cn9.cloudfront.net';

    let normalizedUrl = url;

    if (url.includes(s3Pattern)) {
        normalizedUrl = url.replace(s3Pattern, cloudFrontHost);
    }

    // If it's a site_images path and doesn't have a protocol, prepend CloudFront
    if (normalizedUrl.startsWith('site_images/') || normalizedUrl.startsWith('/site_images/')) {
        const path = normalizedUrl.startsWith('/') ? normalizedUrl.substring(1) : normalizedUrl;
        return `https://${cloudFrontHost}/${path}`;
    }

    // If it's a relative path and doesn't look like a local image, prepend CloudFront
    if (!normalizedUrl.startsWith('http') && !normalizedUrl.startsWith('/') && !normalizedUrl.startsWith('images/')) {
        return `https://${cloudFrontHost}/${normalizedUrl}`;
    }

    // Ensure it starts with / if it's a local relative path
    if (!normalizedUrl.startsWith('http') && !normalizedUrl.startsWith('/')) {
        return `/${normalizedUrl}`;
    }

    return normalizedUrl;
};
